module.exports = __webpack_public_path__ + "static/media/sub_aboutus_banner.cc5b7a7b.jpg";